// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%236B6B6B%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/VokabelnPage/VokabelnPage.css */

.vokabeln-page {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  padding-bottom: calc(var(--space-2xl) + 60px);
  position: relative;
  min-height: 60vh;
}

/* ---- Search Bar ---- */
.vokabeln-search {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.vokabeln-search__input {
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  padding-left: calc(var(--space-md) + 24px);
  padding-right: var(--space-xl);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-full);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  appearance: none;
  box-sizing: border-box;
}

.vokabeln-search__input:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.vokabeln-search__input::placeholder {
  color: var(--color-text-light);
}

.vokabeln-search__icon {
  position: absolute;
  left: var(--space-md);
  font-size: var(--font-size-sm);
  color: var(--color-text-light);
  pointer-events: none;
  line-height: 1;
}

.vokabeln-search__clear {
  position: absolute;
  right: var(--space-sm);
  width: 28px;
  height: 28px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--color-text-light);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  padding: 0;
}

.vokabeln-search__clear:hover,
.vokabeln-search__clear:active {
  background-color: var(--color-progress-bg);
  color: var(--color-text-primary);
}

.vokabeln-search__result-count {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
  text-align: right;
  padding: 0 var(--space-xs);
}

/* ---- Empty State ---- */
.vokabeln-page__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: var(--space-md);
  text-align: center;
  color: var(--color-text-secondary);
}

.vokabeln-page__empty-icon {
  font-size: 3rem;
}

.vokabeln-page__empty-title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.vokabeln-page__empty-text {
  font-size: var(--font-size-sm);
  max-width: 280px;
  line-height: var(--line-height-normal);
}

/* ---- No Results ---- */
.vokabeln-page__no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-2xl) var(--space-md);
  gap: var(--space-md);
  text-align: center;
  color: var(--color-text-secondary);
}

.vokabeln-page__no-results-icon {
  font-size: 2.5rem;
}

.vokabeln-page__no-results-text {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
}

.vokabeln-page__no-results-query {
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

/* ---- Table ---- */
.vokabeln-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}

.vokabeln-table thead {
  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);
}

.vokabeln-table th {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-dark);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
}

.vokabeln-table th:first-child {
  text-align: center;
  width: 40px;
}

.vokabeln-table th:last-child {
  text-align: center;
  width: 80px;
}

.vokabeln-table td {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
  word-break: break-word;
}

.vokabeln-table tbody tr:last-child td {
  border-bottom: none;
}

.vokabeln-table tbody tr {
  transition: background-color var(--transition-fast);
}

.vokabeln-table tbody tr:active {
  background-color: rgba(139, 94, 60, 0.04);
}

/* ---- Info Column ---- */
.vokabeln-table__info-cell {
  text-align: center;
  position: relative;
}

.vokabeln-table__info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-full);
  background-color: transparent;
  border: 1.5px solid var(--color-border);
  color: var(--color-text-light);
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  padding: 0;
  line-height: 1;
}

.vokabeln-table__info-btn:hover,
.vokabeln-table__info-btn--active {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
}

/* ---- Tooltip ---- */
.vokabeln-tooltip {
  position: absolute;
  top: 100%;
  left: 200%;
  transform: translateX(-50%);
  z-index: 50;
  margin-top: var(--space-xs);
  background-color: var(--color-wood-dark);
  color: var(--color-text-on-wood);
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  white-space: nowrap;
  font-size: var(--font-size-xs);
  line-height: var(--line-height-normal);
  animation: tooltip-fade-in 0.15s ease-out;
  min-width: 140px;
  text-align: left;
}

.vokabeln-tooltip::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 6px solid transparent;
  border-bottom-color: var(--color-wood-dark);
}

.vokabeln-tooltip__row {
  display: flex;
  justify-content: space-between;
  gap: var(--space-sm);
}

.vokabeln-tooltip__row + .vokabeln-tooltip__row {
  margin-top: 2px;
}

.vokabeln-tooltip__label {
  font-weight: var(--font-weight-semibold);
  opacity: 0.8;
}

.vokabeln-tooltip__value {
  font-weight: var(--font-weight-bold);
}

@keyframes tooltip-fade-in {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(4px);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* ---- Action Column ---- */
.vokabeln-table__action-cell {
  text-align: center;
  white-space: nowrap;
}

.vokabeln-table__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: var(--radius-sm);
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: var(--font-size-base);
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  padding: 0;
}

.vokabeln-table__action-btn--edit {
  color: var(--color-wood-medium);
}

.vokabeln-table__action-btn--edit:hover,
.vokabeln-table__action-btn--edit:active {
  background-color: rgba(139, 94, 60, 0.1);
}

.vokabeln-table__action-btn--delete {
  color: var(--color-error);
}

.vokabeln-table__action-btn--delete:hover,
.vokabeln-table__action-btn--delete:active {
  background-color: rgba(229, 57, 53, 0.1);
}

/* ---- Floating Action Button ---- */
.vokabeln-fab {
  position: fixed;
  bottom: calc(var(--bottom-nav-height) + var(--space-lg));
  right: var(--space-lg);
  z-index: 90;
  width: 56px;
  height: 56px;
  border-radius: var(--radius-full);
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border: none;
  box-shadow: 0 4px 12px rgba(92, 58, 30, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.vokabeln-fab:hover {
  background-color: var(--color-wood-dark);
  box-shadow: 0 6px 16px rgba(92, 58, 30, 0.45);
}

.vokabeln-fab:active {
  transform: scale(0.92);
  box-shadow: 0 2px 8px rgba(92, 58, 30, 0.3);
}

.vokabeln-fab__icon {
  font-size: 1.75rem;
  font-weight: var(--font-weight-bold);
  line-height: 1;
}

@media (min-width: 481px) {
  .vokabeln-fab {
    right: calc(50% - var(--max-content-width) / 2 + var(--space-lg));
  }
}

/* ---- Dialog Overlay ---- */
.vokabeln-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
  animation: overlay-fade-in 0.2s ease-out;
}

@keyframes overlay-fade-in {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.vokabeln-dialog {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 380px;
  max-height: 90vh;
  overflow-y: auto;
  animation: dialog-slide-up 0.25s ease-out;
}

@keyframes dialog-slide-up {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.vokabeln-dialog__header {
  padding: var(--space-lg) var(--space-lg) var(--space-sm);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.vokabeln-dialog__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
}

.vokabeln-dialog__close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  font-size: var(--font-size-lg);
  color: var(--color-text-light);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.vokabeln-dialog__close:hover {
  background-color: var(--color-progress-bg);
  color: var(--color-text-primary);
}

.vokabeln-dialog__body {
  padding: var(--space-sm) var(--space-lg) var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

/* ---- Form Fields ---- */
.vokabeln-form-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.vokabeln-form-field__label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
}

.vokabeln-form-field__input,
.vokabeln-form-field__select {
  padding: var(--space-sm) var(--space-md);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast);
  appearance: none;
}

.vokabeln-form-field__input:focus,
.vokabeln-form-field__select:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.vokabeln-form-field__input::placeholder {
  color: var(--color-text-light);
}

.vokabeln-form-field__select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

/* ---- Dialog Actions ---- */
.vokabeln-dialog__actions {
  display: flex;
  gap: var(--space-sm);
  padding-top: var(--space-sm);
}

.vokabeln-dialog__btn {
  flex: 1 1;
  padding: var(--space-sm) var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  border: none;
  text-align: center;
}

.vokabeln-dialog__btn--cancel {
  background-color: var(--color-progress-bg);
  color: var(--color-text-secondary);
}

.vokabeln-dialog__btn--cancel:active {
  background-color: var(--color-border);
}

.vokabeln-dialog__btn--save {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  box-shadow: var(--shadow-sm);
}

.vokabeln-dialog__btn--save:active {
  background-color: var(--color-wood-dark);
}

.vokabeln-dialog__btn--save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.vokabeln-dialog__btn--delete {
  background-color: var(--color-error);
  color: white;
  box-shadow: var(--shadow-sm);
}

.vokabeln-dialog__btn--delete:active {
  opacity: 0.85;
}

/* ---- Confirm Dialog ---- */
.vokabeln-confirm__icon {
  font-size: 2.5rem;
  text-align: center;
}

.vokabeln-confirm__message {
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  text-align: center;
  line-height: var(--line-height-normal);
}

.vokabeln-confirm__word {
  font-weight: var(--font-weight-bold);
  color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/pages/VokabelnPage/VokabelnPage.css"],"names":[],"mappings":"AAAA,iGAAiG;;AAEjG;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,0CAA0C;EAC1C,8BAA8B;EAC9B,uCAAuC;EACvC,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,kFAAkF;EAElF,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;;EAEE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,gCAAgC;EAChC,4CAA4C;EAC5C,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,2BAA2B;EAC3B,wCAAwC;EACxC,gCAAgC;EAChC,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,8BAA8B;EAC9B,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,sCAAsC;EACtC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,wDAAwD;EACxD,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,gCAAgC;EAChC,YAAY;EACZ,6CAA6C;EAC7C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE;IACE,iEAAiE;EACnE;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;;EAEE,wCAAwC;EACxC,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,+CAA+C;EAE/C,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,+BAA+B;EAC/B,gCAAgC;EAChC,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/VokabelnPage/VokabelnPage.css */\n\n.vokabeln-page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  padding-bottom: calc(var(--space-2xl) + 60px);\n  position: relative;\n  min-height: 60vh;\n}\n\n/* ---- Search Bar ---- */\n.vokabeln-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.vokabeln-search__input {\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  padding-left: calc(var(--space-md) + 24px);\n  padding-right: var(--space-xl);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n  box-sizing: border-box;\n}\n\n.vokabeln-search__input:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.vokabeln-search__input::placeholder {\n  color: var(--color-text-light);\n}\n\n.vokabeln-search__icon {\n  position: absolute;\n  left: var(--space-md);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-light);\n  pointer-events: none;\n  line-height: 1;\n}\n\n.vokabeln-search__clear {\n  position: absolute;\n  right: var(--space-sm);\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: var(--color-text-light);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  padding: 0;\n}\n\n.vokabeln-search__clear:hover,\n.vokabeln-search__clear:active {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-primary);\n}\n\n.vokabeln-search__result-count {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n  text-align: right;\n  padding: 0 var(--space-xs);\n}\n\n/* ---- Empty State ---- */\n.vokabeln-page__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 40vh;\n  gap: var(--space-md);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.vokabeln-page__empty-icon {\n  font-size: 3rem;\n}\n\n.vokabeln-page__empty-title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.vokabeln-page__empty-text {\n  font-size: var(--font-size-sm);\n  max-width: 280px;\n  line-height: var(--line-height-normal);\n}\n\n/* ---- No Results ---- */\n.vokabeln-page__no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-2xl) var(--space-md);\n  gap: var(--space-md);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.vokabeln-page__no-results-icon {\n  font-size: 2.5rem;\n}\n\n.vokabeln-page__no-results-text {\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-normal);\n}\n\n.vokabeln-page__no-results-query {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n/* ---- Table ---- */\n.vokabeln-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  overflow: hidden;\n}\n\n.vokabeln-table thead {\n  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);\n}\n\n.vokabeln-table th {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-dark);\n  text-align: left;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n}\n\n.vokabeln-table th:first-child {\n  text-align: center;\n  width: 40px;\n}\n\n.vokabeln-table th:last-child {\n  text-align: center;\n  width: 80px;\n}\n\n.vokabeln-table td {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n  word-break: break-word;\n}\n\n.vokabeln-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.vokabeln-table tbody tr {\n  transition: background-color var(--transition-fast);\n}\n\n.vokabeln-table tbody tr:active {\n  background-color: rgba(139, 94, 60, 0.04);\n}\n\n/* ---- Info Column ---- */\n.vokabeln-table__info-cell {\n  text-align: center;\n  position: relative;\n}\n\n.vokabeln-table__info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-full);\n  background-color: transparent;\n  border: 1.5px solid var(--color-border);\n  color: var(--color-text-light);\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  padding: 0;\n  line-height: 1;\n}\n\n.vokabeln-table__info-btn:hover,\n.vokabeln-table__info-btn--active {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n}\n\n/* ---- Tooltip ---- */\n.vokabeln-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 200%;\n  transform: translateX(-50%);\n  z-index: 50;\n  margin-top: var(--space-xs);\n  background-color: var(--color-wood-dark);\n  color: var(--color-text-on-wood);\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-lg);\n  white-space: nowrap;\n  font-size: var(--font-size-xs);\n  line-height: var(--line-height-normal);\n  animation: tooltip-fade-in 0.15s ease-out;\n  min-width: 140px;\n  text-align: left;\n}\n\n.vokabeln-tooltip::before {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 6px solid transparent;\n  border-bottom-color: var(--color-wood-dark);\n}\n\n.vokabeln-tooltip__row {\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-sm);\n}\n\n.vokabeln-tooltip__row + .vokabeln-tooltip__row {\n  margin-top: 2px;\n}\n\n.vokabeln-tooltip__label {\n  font-weight: var(--font-weight-semibold);\n  opacity: 0.8;\n}\n\n.vokabeln-tooltip__value {\n  font-weight: var(--font-weight-bold);\n}\n\n@keyframes tooltip-fade-in {\n  0% {\n    opacity: 0;\n    transform: translateX(-50%) translateY(4px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* ---- Action Column ---- */\n.vokabeln-table__action-cell {\n  text-align: center;\n  white-space: nowrap;\n}\n\n.vokabeln-table__action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: var(--radius-sm);\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: var(--font-size-base);\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  padding: 0;\n}\n\n.vokabeln-table__action-btn--edit {\n  color: var(--color-wood-medium);\n}\n\n.vokabeln-table__action-btn--edit:hover,\n.vokabeln-table__action-btn--edit:active {\n  background-color: rgba(139, 94, 60, 0.1);\n}\n\n.vokabeln-table__action-btn--delete {\n  color: var(--color-error);\n}\n\n.vokabeln-table__action-btn--delete:hover,\n.vokabeln-table__action-btn--delete:active {\n  background-color: rgba(229, 57, 53, 0.1);\n}\n\n/* ---- Floating Action Button ---- */\n.vokabeln-fab {\n  position: fixed;\n  bottom: calc(var(--bottom-nav-height) + var(--space-lg));\n  right: var(--space-lg);\n  z-index: 90;\n  width: 56px;\n  height: 56px;\n  border-radius: var(--radius-full);\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border: none;\n  box-shadow: 0 4px 12px rgba(92, 58, 30, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.vokabeln-fab:hover {\n  background-color: var(--color-wood-dark);\n  box-shadow: 0 6px 16px rgba(92, 58, 30, 0.45);\n}\n\n.vokabeln-fab:active {\n  transform: scale(0.92);\n  box-shadow: 0 2px 8px rgba(92, 58, 30, 0.3);\n}\n\n.vokabeln-fab__icon {\n  font-size: 1.75rem;\n  font-weight: var(--font-weight-bold);\n  line-height: 1;\n}\n\n@media (min-width: 481px) {\n  .vokabeln-fab {\n    right: calc(50% - var(--max-content-width) / 2 + var(--space-lg));\n  }\n}\n\n/* ---- Dialog Overlay ---- */\n.vokabeln-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-md);\n  animation: overlay-fade-in 0.2s ease-out;\n}\n\n@keyframes overlay-fade-in {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n.vokabeln-dialog {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 380px;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: dialog-slide-up 0.25s ease-out;\n}\n\n@keyframes dialog-slide-up {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.vokabeln-dialog__header {\n  padding: var(--space-lg) var(--space-lg) var(--space-sm);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.vokabeln-dialog__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n}\n\n.vokabeln-dialog__close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  font-size: var(--font-size-lg);\n  color: var(--color-text-light);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.vokabeln-dialog__close:hover {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-primary);\n}\n\n.vokabeln-dialog__body {\n  padding: var(--space-sm) var(--space-lg) var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n/* ---- Form Fields ---- */\n.vokabeln-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.vokabeln-form-field__label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n}\n\n.vokabeln-form-field__input,\n.vokabeln-form-field__select {\n  padding: var(--space-sm) var(--space-md);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n}\n\n.vokabeln-form-field__input:focus,\n.vokabeln-form-field__select:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.vokabeln-form-field__input::placeholder {\n  color: var(--color-text-light);\n}\n\n.vokabeln-form-field__select {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236B6B6B' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n}\n\n/* ---- Dialog Actions ---- */\n.vokabeln-dialog__actions {\n  display: flex;\n  gap: var(--space-sm);\n  padding-top: var(--space-sm);\n}\n\n.vokabeln-dialog__btn {\n  flex: 1;\n  padding: var(--space-sm) var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  border: none;\n  text-align: center;\n}\n\n.vokabeln-dialog__btn--cancel {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-secondary);\n}\n\n.vokabeln-dialog__btn--cancel:active {\n  background-color: var(--color-border);\n}\n\n.vokabeln-dialog__btn--save {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  box-shadow: var(--shadow-sm);\n}\n\n.vokabeln-dialog__btn--save:active {\n  background-color: var(--color-wood-dark);\n}\n\n.vokabeln-dialog__btn--save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.vokabeln-dialog__btn--delete {\n  background-color: var(--color-error);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.vokabeln-dialog__btn--delete:active {\n  opacity: 0.85;\n}\n\n/* ---- Confirm Dialog ---- */\n.vokabeln-confirm__icon {\n  font-size: 2.5rem;\n  text-align: center;\n}\n\n.vokabeln-confirm__message {\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  text-align: center;\n  line-height: var(--line-height-normal);\n}\n\n.vokabeln-confirm__word {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-error);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
